/**
 * colGroup.jsx
 *
 * @Author: apple
 * @Date: 2018/3/8 16:55
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
/**
 * @ignore
 * */
export default function ColGroup(props) {
    const { renderColumns } = props;
    return (
        <colgroup>
            {renderColumns.map((item, index) => {
                const { colClassName, width, colSpan = 1 } = item;
                return <col span={colSpan} className={colClassName} style={{ width }} key={`col-${index}`} />;
            })}
        </colgroup>
    );
}



// WEBPACK FOOTER //
// ./src/table/colGroup.jsx